var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full relative border border-solid rounded-lg",class:{
    'text-white text-sm border-grey-700': _vm.hasState('dark'),
    'text-grey-600 border-grey-200': !_vm.hasState('dark')
  }},[_c('textarea',{ref:"input",staticClass:"w-full h-full outline-none rounded-lg px-2 resize-none py-2",class:{
      'bg-grey-800': _vm.hasState('dark'),
      'bg-white': !_vm.hasState('dark')
    },staticStyle:{"min-height":"200px"},attrs:{"placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"input":_vm.onInput,"keyup":_vm.keyup,"keydown":_vm.keydown}})])
}
var staticRenderFns = []

export { render, staticRenderFns }